function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.65,
  fillRule: "nonzero",
  d: "M2.094 1.695h5.812A.094.094 0 0 0 8 1.602V.945a.094.094 0 0 0-.094-.093H2.094A.094.094 0 0 0 2 .945v.657c0 .051.042.093.094.093zm5.812 4.97A.094.094 0 0 0 8 6.57v-.656a.094.094 0 0 0-.094-.094H2.094A.094.094 0 0 0 2 5.914v.656c0 .052.042.094.094.094h5.812zm1.688 1.64H.406a.094.094 0 0 0-.094.093v.657c0 .051.043.093.094.093h9.188a.094.094 0 0 0 .094-.093v-.657a.094.094 0 0 0-.094-.093zm0-4.97H.406a.094.094 0 0 0-.094.095v.656c0 .051.043.094.094.094h9.188a.094.094 0 0 0 .094-.094V3.43a.094.094 0 0 0-.094-.094z"
});

var SvgAlignCenter = function SvgAlignCenter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAlignCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/align-center.8b4dbcd4.svg";
export { ForwardRef as ReactComponent };